(() => {
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  // Gallery thumbnails scroll their slide into view (RTL-safe).
  qa('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const slide = document.getElementById(thumb.dataset.thumb);
      if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      qa('[data-thumb]', thumb.parentElement).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    });
  });

  // Gallery arrows move one slide (RTL-safe: scrollBy follows the reading direction).
  qa('[data-gallery-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const gallery = btn.parentElement.querySelector('[data-gallery]');
      const rtl = getComputedStyle(gallery).direction === 'rtl' ? -1 : 1;
      gallery.scrollBy({ left: gallery.clientWidth * Number(btn.dataset.galleryStep) * rtl, behavior: 'smooth' });
    });
  });

  // Quantity steppers.
  qa('[data-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
    });
  });

  const money = (cents, format) => {
    const fixed = (n, d, t = ',', s = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fixed(cents, 2),
      amount_no_decimals: fixed(cents, 0),
      amount_with_comma_separator: fixed(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fixed(cents, 0, '.'),
    })[key] ?? fixed(cents, 2));
  };

  // Variant option pickers.
  qa('form[data-product-form]').forEach((form) => {
    const data = form.querySelector('[data-variants]');
    if (!data) return;
    const { variants, format, save, soldOut, add } = JSON.parse(data.textContent);
    const section = form.closest('section');
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-opt]')) return;
      const picked = qa('fieldset[data-option]', form).map((f) => f.querySelector('input:checked')?.value);
      const v = variants.find((x) => x.options.every((o, i) => o === picked[i]));
      const btns = qa('[data-buy], [data-sticky-btn]', section);
      if (!v) { btns.forEach((b) => (b.disabled = true)); return; }
      form.querySelector('[data-variant-id]').value = v.id;
      qa('[data-price]', section).forEach((el) => (el.textContent = money(v.price, format)));
      const onSale = v.compare_at_price > v.price;
      qa('[data-compare]', section).forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? money(v.compare_at_price, format) : ''; });
      qa('[data-save]', section).forEach((el) => { el.hidden = !onSale; el.textContent = onSale ? save.replace('%p', Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)) : ''; });
      btns.forEach((b) => (b.disabled = !v.available));
      qa('[data-buy-label]', section).forEach((el) => (el.textContent = v.available ? add : soldOut));
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
      // Bundle offer cards: checked state and each card's price for the other picked options.
      const names = qa('fieldset[data-option]', form).map((f) => f.dataset.optionName);
      qa('[data-offer-card]', section).forEach((card) => {
        const pos = names.indexOf(card.dataset.offerOption);
        if (pos < 0) return;
        card.setAttribute('aria-checked', String(picked[pos] === card.dataset.offerValue));
        const cv = variants.find((x) => x.options.every((o, i) => o === (i === pos ? card.dataset.offerValue : picked[i])));
        if (!cv) return;
        const label = card.closest('[data-offer-group]').dataset.offerSaveLabel || '';
        const sale = cv.compare_at_price > cv.price;
        qa('[data-offer-price]', card).forEach((el) => (el.textContent = money(cv.price, format)));
        qa('[data-offer-compare]', card).forEach((el) => { el.hidden = !sale; el.textContent = sale ? money(cv.compare_at_price, format) : ''; });
        qa('[data-offer-save]', card).forEach((el) => { el.hidden = !sale; el.textContent = sale ? label.replace('%a', money(cv.compare_at_price - cv.price, format)) : ''; });
      });
    });
  });

  // Bundle offer cards act as one radio group; the hidden option radio drives the variant change above.
  qa('[data-offer-group]').forEach((group) => {
    const cards = qa('[data-offer-card]', group);
    const pick = (card) => {
      cards.forEach((c) => c.tabIndex = c === card ? 0 : -1);
      cards.forEach((c) => c.setAttribute('aria-checked', String(c === card)));
      const input = qa('fieldset[data-option] input[data-opt]', group.closest('section') || document)
        .find((i) => i.closest('fieldset').dataset.optionName === card.dataset.offerOption && i.value === card.dataset.offerValue);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    const checked = cards.find((c) => c.getAttribute('aria-checked') === 'true') || cards[0];
    cards.forEach((c) => (c.tabIndex = c === checked ? 0 : -1));
    cards.forEach((card) => {
      card.addEventListener('click', () => pick(card));
      card.addEventListener('keydown', (e) => {
        const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (step) {
          e.preventDefault();
          const next = cards[(cards.indexOf(card) + step + cards.length) % cards.length];
          pick(next);
          next.focus();
          return;
        }
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        pick(card);
      });
    });
  });

  // Optional: skip the cart page and go straight to checkout.
  qa('form[data-direct-checkout="true"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, { method: 'POST', body: new FormData(form) })
        .then((r) => (r.ok ? (location.href = '/checkout') : form.submit()))
        .catch(() => form.submit());
    });
  });

  // Sticky buy bar appears once the main buy button scrolls out of view.
  const buy = document.querySelector('[data-buy]');
  if (buy && document.querySelector('[data-sticky]') && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('sticky-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(buy);
  }
})();
